<div class="container">
    <section class="inner-container">
    <main>
        <section data-parallax="full" class="product-detail-banner">
            <div class="caption center-full" style="background-image: url(images/submit-bg.jpg); background-size: cover; height: 80vh; padding-top: 9vh">
                <div class="inner">
                <h2>Thank you.</h2>
                <p class="point">
                    You have successfully submitted your application.<br>
                    We will notify you via email once your application is approved.<br>
                </p><br>
                    <button class="btn btn-primary" (click)="home()"> BACK TO HOMEPAGE </button> &nbsp; &emsp;
                    <button class="btn btn-primary" (click)="dash()"> GO TO MY DASHBOARD </button>                  
                </div>
            </div>
        </section>
    </main>
    </section>
</div>
